// Minimal local mirror of the parts of the axe-core result we consume.
// Kept local so this module has NO dependency on axe-core (pure + fast tests).
export interface AxeNode {
  html: string
  target: string[]
  failureSummary?: string
}

export interface AxeViolation {
  id: string
  impact?: string
  help: string
  helpUrl?: string
  nodes: AxeNode[]
}

// Structurally identical to A11yWarningPanel's Issue type (kept in sync intentionally;
// they communicate across an untyped window CustomEvent boundary).
export interface AxeIssue {
  type: string
  message: string
  context?: string
  label?: string
  helpUrl?: string
  impact?: string
}

export function mapAxeViolations(violations: AxeViolation[]): AxeIssue[] {
  const issues: AxeIssue[] = []
  for (const v of violations) {
    for (const node of v.nodes) {
      issues.push({
        type: v.id,
        message: node.failureSummary || v.help,
        context: node.html.slice(0, 120),
        label: v.help,
        helpUrl: v.helpUrl,
        impact: v.impact,
      })
    }
  }
  return issues
}
